import React from "react";
import { Button } from "antd";
import WrappedLoginForm from "./loginForm.js";
import styles from "./login.module.css";

class LoginSlide extends React.Component {
    constructor(props) {
        super(props);
    }

  render() {
    return (
      <div className={styles.container}>
        <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
          <div style={{ flex: "11" }}>
            <div
              style={{
                backgroundColor: "#2679bd",
                fontWeight: "600",
                color: "white",
                fontSize: "1.15vw",
                paddingBottom: "0.5em",
                paddingTop: "0.5em",
                borderRadius: "6px 6px 0px 0px"
              }}
            >
              <span style={{ paddingLeft: "1.2em" }}>ВХОД</span>
            </div>
          </div>
          <div style={{ flex: "1" }} />
          <div style={{ flex: "9.3" }} />
        </div>

        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ flex: "11" }}>
            <div className={styles.loginFormContainer}>
              <WrappedLoginForm />
              <div style={{ paddingBottom: "4vh" }}>
                <a
                  href="#"
                  onClick={this.handleRecoverClick}
                  style={{
                    paddingLeft: "20.83333333%",
                    textDecoration: "underline"
                  }}
                >
                  Восстановить мой пароль
                </a>
              </div>
            </div>
          </div>
          <div style={{ flex: "1" }} />
          <div style={{ flex: "9.3" }}>
            <div style={{ fontWeight: "600", fontSize: "1.07vw" }}>
              В поле «Имя» нужно ввести:
            </div>
            <div style={{ paddingTop: "0.8vh" }}>
              <ul className="globalLoginUlList">
                <li style={{ display: "list-item" }}>
                  Для абонентов - номер, например «0818/086»
                </li>
                <li style={{ display: "list-item" }}>
                  Для обслуживающих организаций - наименование организации,
                  например «Энергомер»
                </li>
              </ul>
            </div>

            <div className={styles.demoButton}>
                <Button
                    onClick={this.props.demoEnter}
                    type="primary"
                    htmlType="submit">
                    ДЕМО-ДОСТУП
                </Button>
            </div>
            <br />
                    <div style={{ textAlign: "center", width: "50%" }}>
                <a href="Documents/Руководство по эксплуатации АСУТ-601М2.pdf" target="_blank"> Скачать руководство <br />ИС "Теплоинформ"</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoginSlide;
